/* eslint-disable prettier/prettier */
import i18n from "i18n";
import { tPlateType, tReportStatus } from "i18n/enums";

export const ERROR_MESSAGE = i18n.t("Action failed, please try again");
export const SUCCESS_MESSAGE = i18n.t("Action completed successfully");

export const checkBoxNames = {
  licenseNumberUnclear: "licenseNumberUnclear",
  dataDoesNotMatch: "dataDoesNotMatch",
  missingDetails: "missingDetails",
  roadMarkUnclear: "roadMarkUnclear",
  reportForImmediateTreatment: "reportForImmediateTreatment",
  recommendForInformationalMaterial: "recommendForInformationalMaterial",
};
export const TheDriverCommitedOnEnum = {
  1: "projectProcedures",
  2: "trafficLawsMinorOffense",
  3: "trafficLawsSriousOffense",
};
export enum ReportRejectionReasonType {
  licenseNumberUnclear = 1,
  offenseCannotBeIdentified = 2,
  UploadedByMistakeOrForReview = 3,
  other = 4,
  knowTheDriver = 5,
  inappropriateBehavior = 6,
  recordBehavior = 7,
  systemRejection = 8,
  reportIncompleteInTime = 9,
}

export const ACCORDING_TO_CIRCUMSTANCES = "בהתאם לנסיבות";

export const PoliceDecisionArray = [
  {
    code: 1,
    name: "Disqualified",
  },
  {
    code: 2,
    name: "Ticket",
  },
  {
    code: 3,
    name: "Court summons",
  },
];

export enum DecisionTypesCode {
  InformationLetter = 1,
  SevereInformationLetter = 2,
  PackingForPolice = 3,
  DisqualificationReport = 4,
  Testing = 5,
  Obsolescence = 6,
  NotPrioritized = 7,
}

export const DecisionsTypeArray = [
  {
    code: 1,
    name: "Information letter",
  },
  {
    code: 2,
    name: "Severe information letter",
  },
  {
    code: 3,
    name: "Packing for police",
  },
  {
    code: 4,
    name: "Report disqualification",
  },
  {
    code: 5,
    name: "Testing",
  },
  {
    code: 6,
    name: "Obsolescence",
  },
  {
    code: 7,
    name: "Not prioritized",
  },
];

export const PoliceRejectionReasonArray = [
  {
    code: 1,
    name: "Traffic accident",
  },
  {
    code: 2,
    name: "Duplicate event - event sent twice",
  },
  {
    code: 3,
    name: "Public transport lane - enforcement not yet approved",
  },
  {
    code: 4,
    name: "Closed - no fault",
  },
  {
    code: 5,
    name: "Closed - lack of evidence",
  },
  {
    code: 6,
    name: "Closed - no public interest",
  },
];

export const whatIsReportProblematic = {
  1: "carelessDrivingEndangersOthers",
  2: "carelessDrivingEndangersItself",
  3: "documenterCommitsAnOffenseHimself",
  4: "neighborConflict",
  5: "behaviorDoesNotSuitProject",
  6: "other",
};

export const licensePlate = {
  1: "ISRAELY",
  2: "MILITARY",
  3: "PALESTINIAN",
  4: "FOREIGN",
  5: "DIPLOMATIC",
  6: "Police",
  7: "OperatingVehicle",
  8: "Other",
};
export function mapLicensePlateValue(value: number) {
  return licensePlate[value];
}
const licensePlateEnumKeys = Object.entries(licensePlate);

export function convertLicensePlateEnumToArray(): {
  value: number;
  label: string;
}[] {
  return licensePlateEnumKeys.map((key) => ({
    value: Number(key[0]),
    // D-08: finite plate-type enum localized client-side via the lookup helper
    // (keyed by the stable numeric code) instead of the raw Hebrew label.
    label: tPlateType(Number(key[0])),
  }));
}

export enum ReportStatusType {
  ALL = "כל הסטטוסים",
}

export enum UserRole {
  REGULAR = 1,
  SENIOR = 2,
  CONTROLCENTER = 3,
  SENIOR_WATCH = 5, // its 5 because the server already have 4 for volunteer
}

export const StatusesEnums = {
  REPORT_COMPLETION_BY_VOLUNTEER: {
    id: 1,
    type: 'השלמת דיווח ע"י מתנדב',
    text: {
      [UserRole.REGULAR]: 'השלמת דיווח ע"י מתנדב',
      [UserRole.SENIOR]: 'השלמת דיווח ע"י מתנדב',
      [UserRole.CONTROLCENTER]: 'השלמת דיווח ע"י מתנדב',
      [UserRole.SENIOR_WATCH]: 'השלמת דיווח ע"י מתנדב',
    },
  },
  VOLUNTEER_REPAIR_PENDING: {
    id: 2,
    type: "ממתין לתיקון מתנדב",
    text: {
      [UserRole.REGULAR]: "ממתין לתיקון מדווח",
      [UserRole.SENIOR]: "ממתין לתיקון מדווח",
      [UserRole.CONTROLCENTER]: "ממתין למתנדב",
      [UserRole.SENIOR_WATCH]: "ממתין לתיקון מתנדב",
    },
  },
  NEW: {
    id: 3,
    type: "לטיפול בקר רגיל-חדש",
    text: {
      [UserRole.REGULAR]: "חדש",
      [UserRole.SENIOR]: "ממתין לבקר",
      [UserRole.CONTROLCENTER]: "ממתין לבקר",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול בקר רגיל",
    },
  },
  REPEAT_FROM_PENDING: {
    id: 4,
    type: "לטיפול בקר רגיל-חזר ממתנדב",
    text: {
      [UserRole.REGULAR]: "תוקן על ידי מדווח",
      [UserRole.SENIOR]: "ממתין לבקר רגיל",
      [UserRole.CONTROLCENTER]: "ממתין לבקר",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול בקר רגיל",
    },
  },
  SENIOR_CONTROL_NEW: {
    id: 5,
    type: "לטיפול בקר בכיר-חדש",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "חדש",
      [UserRole.CONTROLCENTER]: "ממתין לבקר",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול בקר בכיר",
    },
  },
  SENIOR_CONTROL_PENDING: {
    id: 6,
    type: "ממתין לתיקון בקר בכיר",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "חזר ממרכז הבקרה",
      [UserRole.CONTROLCENTER]: "הועבר לתיקון בקר בכיר",
      [UserRole.SENIOR_WATCH]: "ממתין לתיקון בקר בכיר",
    },
  },
  SENIOR_CONTROL_FROM_AWAITING: {
    id: 7,
    type: "לטיפול בקר בכיר-חזר ממתנדב",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "תוקן על ידי מדווח",
      [UserRole.CONTROLCENTER]: "ממתין לבקר",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול בקר בכיר",
    },
  },
  CENTER_CONTROL_NEW: {
    id: 8,
    type: "לטיפול מרכז בקרה ממתין לאריזה למשטרה",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "ממתין למרכז בקרה",
      [UserRole.CONTROLCENTER]: "ממתין לאריזה למשטרה",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול מרכז בקרה",
    },
  },
  CENTER_CONTROL_PENDING: {
    id: 9,
    type: "לטיפול מרכז בקרה ממתין לשליחת מכתב",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "ממתין למרכז בקרה",
      [UserRole.CONTROLCENTER]: "ממתין לשליחת מכתב",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול מרכז בקרה",
    },
  },
  CENTER_CONTROL_FROM_AWAITING: {
    id: 10,
    type: "לטיפול מרכז בקרה- חזר מבקרה",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "ממתין למרכז בקרה",
      [UserRole.CONTROLCENTER]: "חזר מתיקון בקר בכיר",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול מרכז בקרה",
    },
  },
  AWAITING_FEEDBACK: {
    id: 11,
    type: "ממתין להיזון חוזר",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "ממתין להיזון חוזר",
      [UserRole.CONTROLCENTER]: "ממתין להיזון חוזר",
      [UserRole.SENIOR_WATCH]: "ממתין להיזון חוזר",
    },
  },
  COMPLETED: {
    id: 12,
    type: "טיפול הושלם",
    text: {
      [UserRole.REGULAR]: "טיפול הושלם",
      [UserRole.SENIOR]: "טיפול הושלם",
      [UserRole.CONTROLCENTER]: "טיפול הושלם",
      [UserRole.SENIOR_WATCH]: "טיפול הושלם",
    },
  },
  AWAITING_A_SECOND_INSPECTION: {
    id: 13,
    type: "ממתין לבקרה שניה",
    text: {
      [UserRole.REGULAR]: "ממתין לבקרה",
      [UserRole.SENIOR]: "ממתין לבקרה שניה",
      [UserRole.CONTROLCENTER]: "ממתין לבקר",
      [UserRole.SENIOR_WATCH]: "ממתין לטיפול בקר בכיר",
    },
  },
  REPORT_IN_TEST_MODE: {
    id: 14,
    type: "דיווח בבחינה",
    text: {
      [UserRole.REGULAR]: "דיווח בבחינה",
      [UserRole.SENIOR]: "דיווח בבחינה",
      [UserRole.CONTROLCENTER]: "דיווח בבחינה",
    },
  },
  WITHDRWAN_BY_CONTROL_CENTER: {
    id: 15,
    type: "בטיפול מרכז בקרה",
    text: {
      [UserRole.REGULAR]: "בטיפול מרכז בקרה",
      [UserRole.SENIOR]: "בטיפול מרכז בקרה",
      [UserRole.CONTROLCENTER]: "בטיפול מרכז בקרה",
    },
  },
  START_PROCESS_SEND_TO_POLICE: {
    id: 16,
    type: "החל תהליך שליחה למשטרה",
    text: {
      [UserRole.REGULAR]: "החל תהליך שליחה למשטרה",
      [UserRole.SENIOR]: "החל תהליך שליחה למשטרה",
      [UserRole.CONTROLCENTER]: "החל תהליך שליחה למשטרה",
    },
  },
  REGULAR_CONTOL_FROM_SENIOR: {
    id: 17,
    type: "לטיפול בקר רגיל-חזר מבקר בכיר",
    text: {
      [UserRole.REGULAR]: "חזר לתיקון מבקר בכיר",
      [UserRole.SENIOR]: "ממתין לתיקון בקר רגיל",
      [UserRole.CONTROLCENTER]: "ממתין לתיקון בקר רגיל",
    },
  },
};
export enum FilterType {
  controllersType = 1,
  volunteersType = 2,
  reportType = 3,
}
export const AwaitingASecondInspectionStatuses = () => {
  return Object.values(StatusesEnums).filter((status) => {
    return status.text[UserRole.SENIOR] === "ממתין לבקרה שניה";
  });
};

export const AwaitingASecondInspectionStatuseIds =
  AwaitingASecondInspectionStatuses().map((status) => status.id);

// D-08: localized DISPLAY label for a report status, resolved through the enum
// lookup layer (tReportStatus). The hardcoded StatusesEnums.text/type Hebrew
// strings above remain the canonical IDENTITY used to MATCH backend-provided
// status strings (getStatusColor, reportsBase merge) — only display labels are
// localized here. Falls back to the canonical text[role] (then the raw id).
export const getReportStatusLabel = (
  id: number,
  role: number | UserRole
): string => {
  const statusEntry = Object.values(StatusesEnums).find(
    (status) => status.id === id
  );
  const fallback = statusEntry?.text[role as UserRole] ?? String(id);
  const localized = tReportStatus(id, role);
  // tReportStatus already falls back to String(id); prefer the canonical Hebrew
  // text[role] as the fallback when the flat key is missing for this id/role pair.
  return localized === String(id) ? fallback : localized;
};

export const renderTitle = [i18n.t("video"), i18n.t("wizardStep2Title")];
